<template>
  <div
    v-if="generatedSummary"
    class="generated-summary-wrapper margin-top-s medium-margin-top-m margin-bottom-m"
  >
    <div class="body-medium margin-bottom-xxs">
      Here's what customers think
    </div>
    <ul
      v-if="isBulletSummary"
      class="body-regular margin-left-xs"
    >
      <li
        v-for="bulletSummary in generatedSummary.summary"
        :key="bulletSummary"
      >
        {{ bulletSummary }}
      </li>
    </ul>
    <div
      v-else
      class="body-regular"
    >
      "{{ generatedSummary.summary }}"
    </div>
    <div class="margin-top-xxs body-small">
      AI-generated summary from {{ totalResultsFormatted }} customers reviews.
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useReviews } from '@composables/reviews/useReviews';
import { thousandsSeparator } from '@utils/thousandsSeparator';

const { generatedSummary, isBulletSummary, totalResults } = useReviews();
const totalResultsFormatted = computed(() => thousandsSeparator(totalResults.value || 0));

</script>

<style scoped lang="scss">
@import '~settingSCSS';

.generated-summary-wrapper {
  max-width: rem-calc(708);
}

.body-regular {
  @include body(regular);
}

.body-small {
  @include body(small);
}

.body-medium {
  @include body(medium);
}
</style>
